import toast from '@components/Common/Toast.js';
import { APIURL, axios } from './axios.js';
import { DETECTION_API_URL } from '/environment.js';

//get cad file
export const fetchCadFileById = async id => {
  const res = await axios.get(`/cad-file/cadfileId/${id}`);
  return res.data;
};

export const fetchCadFileBySharingId = async sharingId => {
  const res = await axios.get(`/cad-file/sharingId/${sharingId}`);
  return res.data;
};

export const fetchCadFileByShortSharingId = async shortSharingId => {
  const res = await axios.get(`/cad-file/shortSharingId/${shortSharingId}`);
  return res.data;
};

export const getCadFileShortSharingId = async cadFileId => {
  const res = await axios.get(`/cad-file/getShortSharingId/${cadFileId}`);
  return res.data;
};

export const changeCadFilePublicAccessLevel = async (sharingId, level) => {
  const res = await axios.put(`/cad-file/shared/${sharingId}`, {
    level,
  });

  return res.data;
};

//background
export const updateFileBackground = async (cadfileId, base64String, mode) => {
  try {
    const res = await axios.post(`/cad-file/backgroundChange/${cadfileId}`, {
      file: base64String,
      mode: mode,
    });

    return res.data;
  } catch (error) {
    console.warn('background url blob SEND error ', error);
    toast.error(
      i18next.t('canvas.toast.updateBackgroundError.title'),
      i18next.t('canvas.toast.updateBackgroundError.description', {
        error: error.message,
      }),
    );
  }
};

export const fetchFileBackground = async cadfileId => {
  try {
    const res = await axios.get(`/cad-file/backgroundFetch/${cadfileId}`);
    return res.data;
  } catch (error) {
    console.warn('background url blob SEND error ', error);
  }
};

//lighting
export const updateFileLighting = async (cadfileId, json) => {
  try {
    const res = await axios.post(`/cad-file/lightingUpdate/${cadfileId}`, {
      file: json,
    });
    return res.data;
  } catch (error) {
    console.warn('could not update lighting info for scene');
  }
};

export const fetchFileLighting = async cadFileId => {
  try {
    const res = await axios.get(`/cad-file/lightingFetch/${cadFileId}`);
    return res.data;
  } catch (error) {
    console.warn('could not fetch lighting info for scene');
  }
};

//upload
export const updateModelsOrder = async (cadfileId, order) => {
  try {
    const res = await axios.post(`/cad-file/orderUpdate/${cadfileId}`, {
      order: JSON.stringify(order),
    });
    return res.data.status;
  } catch (error) {
    console.warn('Cad file Id order SEND error ', error);
  }
};

//email invites
export const sendInviteEmails = async (id, emails) => {
  const res = await axios.post(`/cad-file/${id}/invite`, {
    invitationDetails: emails,
  });
  return res.data;
};
export const getInvitedEmails = async id => {
  const res = await axios.get(`/cad-file/${id}/invited`);
  return res.data;
};
export const updateCadFileInvite = async (id, email, accessLevel) => {
  const res = await axios.put(`cad-file/${id}/invite/update`, {
    email,
    accessLevel,
  });
  return res.data;
};

export const revokeInvite = async (email, id) => {
  const res = await axios.put(`/cad-file/${id}/invite/revoke`, {
    email,
  });
  return res.data;
};

export const getCadFileInvitedProfiles = async cadFileId => {
  const res = await axios.get(`/cad-file/${cadFileId}/invitedProfiles`);
  return res.data;
};

export const changeCommentsEnabled = async (sharingId, enabled) => {
  const res = await axios.put(`/cad-file/commentsEnabled/${sharingId}`, {
    commentsEnabled: enabled ? 1 : 0,
  });
  return res.data;
};

//get models, camera
export const saveCadFile = async (id, data) => {
  const res = await axios.put(`/cad-file/${id}/save`, data);
  return res.data;
};

export const getModel = (reconstructionID, modelType = 'base', vtProfile) => {
  const profileQuery = vtProfile ? `&vtProfile=${vtProfile}` : '';
  return `${APIURL}/reconstruction/model/${reconstructionID}?modelType=${modelType}${profileQuery}`;
};

export const getModelFetch = async (
  reconstructionID,
  modelType = 'base',
  vtProfile,
) => {
  const profileQuery = vtProfile ? `&vtProfile=${vtProfile}` : '';
  const res = await axios.get(
    `/reconstruction/model/${reconstructionID}?modelType=${modelType}${profileQuery}`,
  );
  return res.data;
};

export const getVtStatus = async reconstructionID => {
  const res = await axios.get(
    `/reconstruction/model/${reconstructionID}/vt-status`,
  );
  return res.data;
};

//upload, delete
export const uploadModel = async (scanningTypeID, data) => {
  const res = await axios.post(
    `/reconstruction/model/upload/${scanningTypeID}`,
    data,
  );
  return res.data;
};

export const deleteModelFromCadFile = async id => {
  const res = await axios.delete(`/cad-file/models/delete/${id}`);
  return res.data;
};

export const getAuthority = async cadFileID => {
  const res = await axios.get(`/cad-file/getAuthority/${cadFileID}`);
  return res.data;
};

//drawings
export const fetchDrawings = async (cadFileID, cadModelIds) => {
  const res = await axios.get(`/cad-file/drawings/fetch/${cadFileID}`, {
    params: { modelIds: cadModelIds },
  });
  return res.data;
};

export const saveCurrentDrawing = async (cadFileID, data) => {
  const res = await axios.post(`/cad-file/drawings/save/${cadFileID}`, data);
  return res.data;
};

//models
export const updateCurrentModel = async (cadFileID, cadModelId, data) => {
  const res = await axios.post(`/cad-file/models/update/${cadFileID}`, {
    modelId: cadModelId,
    modelData: data,
  });
  return res.data;
};

export const restoreOriginalModel = async (cadFileId, cadModelId) => {
  const res = await axios.delete(`/cad-file/models/restore/${cadFileId}`, {
    data: { modelId: cadModelId },
  });
  return res.data;
};

// if no UID, it's a new model. if UID, ignore model_name and focus on UID to match existing one.
export const sendLabelsToTrain = async (
  userId,
  data,
  dataType = 'detection',
  modelName = 'Custom Model',
  UID,
) => {
  const res = await axios.post(`${DETECTION_API_URL}/train_${dataType}`, {
    user_id: userId,
    dataset_zip_url: data,
    model_name: modelName,
    UID: UID,
    epochs: 100,
  });
  return res.data;
};

// select which model to USE via UID
export const sendImageToDetect = async (userId, zipUrl, UID, modelName) => {
  const res = await axios.post(`${DETECTION_API_URL}/send_image`, {
    user_id: userId,
    images: [zipUrl],
    UID: UID,
    model_name: modelName,
  });
  return res.data;
};

export const fetchUserModels = async userId => {
  const res = await axios.post(`${DETECTION_API_URL}/get_user_models`, {
    user_id: userId,
  });
  return res.data;
};

export const deleteUserModel = async (userId, UID) => {
  await axios.post(`${DETECTION_API_URL}/delete_user_model`, {
    user_id: userId,
    UID: UID,
  });
  return;
};

//object detection

export const renameReconstructionFile = async (
  reconstructionID,
  newFileOriginalName,
) => {
  try {
    const res = await axios.post('/reconstruction/update/fileName', {
      reconstructionID,
      newFileOriginalName,
    });
    return res.data;
  } catch (error) {
    console.warn('Rename reconstruction file error', error);
    toast.error('Failed to rename file');
    throw error;
  }
};

export const sendTrainingData = async cadFileID => {
  const res = await axios.post(`/cad-file/trainAI/${cadFileID}`);
  return res.data;
};

export const getObjectDetection = async data => {
  const res = await axios.post('/cad-file/objectDetection', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};

export const downloadTrainedModel = async cadFileID => {
  try {
    const response = await axios.get(
      `/cad-file/downloadTrainedModel/${cadFileID}`,
      {
        responseType: 'blob',
        validateStatus: status => true,
      },
    );

    if (response.status !== 200) {
      const errorText = await response.data.text();
      const errorData = JSON.parse(errorText);

      const message =
        errorData?.message ||
        i18next.t('imageViewer.objectDetectionFeature.downloadFailure');
      throw new Error(message);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getImageViaProxy = async imageUrl => {
  const response = await axios.get('/reconstruction/image-proxy', {
    params: {
      url: imageUrl,
    },
    responseType: 'blob',
  });
  return response.data;
};

//S3 bucket access for future use -> allows direct quick API calls to S3 bucket

export const S3Service = {
  // Get image URL (for thumbnails)
  async getImageUrl(thumbnailImageKey) {
    try {
      const response = await axios.get('/reconstruction/image', {
        params: { thumbnailImageKey },
        responseType: 'blob', // For direct image display
      });
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('Error fetching image:', error);
      return null; // Or a placeholder image
    }
  },

  // Get model file URL
  async getModelUrl(reconstructionID) {
    try {
      const response = await axios.get(
        `/reconstruction/model/${reconstructionID}`,
        {
          responseType: 'blob',
        },
      );
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('Error fetching model:', error);
      throw error;
    }
  },

  // Get presigned upload URL
  async getPresignedUploadUrl(scanningTypeID, fileType) {
    try {
      const response = await axios.get(
        `/reconstruction/model/presign/${scanningTypeID}`,
        {
          params: { type: fileType },
        },
      );
      return response.data; // Should contain the presigned URL
    } catch (error) {
      console.error('Error getting presigned URL:', error);
      throw error;
    }
  },

  // Upload file using backend endpoint
  async uploadFile(file, scanningTypeID) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `/reconstruction/model/upload/${scanningTypeID}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },
};
